// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22eJw","colMin":"styles_colMin__1bvq0"};